<template>
    <div>
        <div class="heading-travel-policy">
            <span :class="flyAmericaActObj.isActive ? 'tag is-success' : 'tag'">Standard rule</span>

            <div class="right-content">
                <div class="lefttext">
                    <p class="paragrapgh">{{ title }}</p>
                    <p>Trigger for non-compliant flights.</p>
                    <p>Open Sky Agreement carriers are
                        <span class="rule-config-variable" @click="isEdit = !isEdit">{{ openSkiesLabel }}&nbsp;<b-icon
                                icon="pencil" size="is-small"></b-icon>
                        </span>
                    </p>
                </div>
                <div class="allbtns">
                    <b-switch :rounded="true" :value="flyAmericaActObj.isActive" v-model="flyAmericaActObj.isActive"
                        @input="toggleFlyAmericaActCompliance" :left-label="true">{{ flyAmericaActObj.isActive ? 'Active' :
                            'Inactive' }}
                    </b-switch>
                </div>
            </div>
        </div>
        <div v-if="isEdit" class="edittravelpolicy editTravel2">
            <FlyAmericaStatus :allowOpenSkyVal="openSkiesAllowed" @emitOpenSkyData="getOpenSkyValue" />
            <b-button @click="saveCall">SAVE</b-button>
        </div>
        <StandardRuleActions v-if="flyAmericaActObj.isActive && !isEdit" :ruleObj="flyAmericaActObj"
        :title="title" @save="updateActions" />
    </div>
</template>
<script>
import StandardRuleActions from "../StandardRuleActions.vue";
import FlyAmericaStatus from "../CommonRules/FlyAmericaStatus.vue";
export default {
    name: "",
    props: {
        value: {
            type: [Object],
        },
    },
    components: { 
        FlyAmericaStatus,
        StandardRuleActions
     },
    data() {
        return {
            flyAmericaActObj: this.value
                ? this.value
                : {
                    name: "flyAmericaActCompliance",
                    isActive: false,
                    type: "air",
                    message: "Trigger for flights not compliant with Fly America Act",
                    value: ["usCompliant", "openSkiesCompliant"]
                },
            isEdit: false,
            openSkyValue: null,
            title: "Fly America Act"
        };
    },
    methods: {
        toggleFlyAmericaActCompliance() {

            if (!this.flyAmericaActObj.isActive) {
                // Clear the custom action parameters when deactivating
                this.clearActionParams();
            }

            this.emitRuleObj();
        },
        getOpenSkyValue(val) {
            this.openSkyValue = val;
        },
        toggleOpenSky() {
            // Check if 'openSkiesCompliant' is toggled
            const shouldIncludeOpenSkies = this.openSkyValue === true;

            if (shouldIncludeOpenSkies) {
                // Add 'openSkiesCompliant' to this.flyAmericaActObj.value if it is not already there
                if (!this.flyAmericaActObj.value.includes('openSkiesCompliant')) {
                    this.flyAmericaActObj.value.push('openSkiesCompliant');
                }
            } else {
                // Remove 'openSkiesCompliant' from this.flyAmericaActObj.value
                this.flyAmericaActObj.value = this.flyAmericaActObj.value.filter(value => value !== 'openSkiesCompliant');
            }
        },
        saveCall() {
            this.isEdit = false;

            this.toggleOpenSky();
        },
        clearActionParams() {
            // Reset to default actions when rule is not active ()
            this.flyAmericaActObj.useCustomActions = false;
            delete this.flyAmericaActObj.visibility;
            delete this.flyAmericaActObj.approvalLevel;
            delete this.flyAmericaActObj.notifications;
        },
        updateActions(updatedRule) {
            // Merge the updated properties into flyAmericaActObj
            this.flyAmericaActObj = { ...this.flyAmericaActObj, ...updatedRule };

            // If useCustomActions is false, delete the associated properties
            if (!updatedRule.useCustomActions) {
                this.clearActionParams();
            }

            this.emitRuleObj();
        },
        emitRuleObj() {
            this.$emit("flyAmericaActCompliance", this.flyAmericaActObj);
        }
    },
    mounted() {
        this.flyAmericaActObj.type = "air";
        this.emitRuleObj();
    },
    computed: {
        openSkiesAllowed() {
            return this.flyAmericaActObj.value.includes('openSkiesCompliant');
        },
        openSkiesLabel() {
            return this.openSkiesAllowed ? 'allowed' : 'not allowed';
        }

    },
    watch: {
        value: {
            handler(newVal, prevVal) {
                if (this.value) {
                    this.flyAmericaActObj = this.value;
                }
                this.flyAmericaActObj.type = "air";

                this.emitRuleObj();

            },
            deep: true,
        },
    },
};
</script>
  